/*
  Floating pill nav controller.

  - Reveals the pill once the page scrolls past the real header.
  - Keeps its cart badge in sync with the header's bubble (the theme updates
    that node on add-to-cart; we mirror it rather than duplicating the id).
  - Reuses the theme's existing search trigger instead of shipping a second
    search implementation.

  ES2019 only: no optional chaining, no nullish coalescing — the storefront
  gets a lot of Facebook / Instagram in-app WebView traffic.
*/
(function () {
  var pill = document.querySelector('[data-pill-nav]');
  if (!pill || pill.getAttribute('data-pill-bound') === 'true') return;
  pill.setAttribute('data-pill-bound', 'true');

  var header = document.querySelector('header');

  function threshold() {
    // Reveal just after the header has scrolled away.
    return header ? Math.max(header.clientHeight - 8, 64) : 120;
  }

  var shown = false;
  var limit = threshold();
  var queued = false;

  function apply() {
    queued = false;
    var past = window.scrollY > limit;
    if (past === shown) return;
    shown = past;
    pill.classList.toggle('is-visible', past);
    // Keep it out of the tab order and the a11y tree while hidden.
    pill.setAttribute('aria-hidden', past ? 'false' : 'true');
  }

  function onScroll() {
    // Background tabs and in-app WebViews throttle or suspend rAF entirely.
    // Fall back to applying synchronously so state never goes stale.
    if (document.hidden || typeof window.requestAnimationFrame !== 'function') {
      apply();
      return;
    }
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(apply);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    limit = threshold();
    onScroll();
  }, { passive: true });
  // Re-sync on return to the tab, in case scrolling happened while suspended.
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      queued = false;
      limit = threshold();
      apply();
    }
  });

  apply();

  /* ---- cart badge mirror ---- */
  var target = pill.querySelector('[data-pill-cart-count]');
  var source = document.querySelector('.cart-count-bubble #cart-notification-count')
    || document.querySelector('#cart-notification-count');

  if (target && source && typeof window.MutationObserver === 'function') {
    var sync = function () {
      var value = (source.textContent || '').trim();
      target.textContent = value;
      target.classList.toggle('is-empty', value === '' || value === '0');
    };
    sync();
    new MutationObserver(sync).observe(source, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  /* ---- search: delegate to the header's own trigger ---- */
  var pillSearch = pill.querySelector('[data-pill-search]');
  if (pillSearch) {
    pillSearch.addEventListener('click', function () {
      var real = document.getElementById('header_search__action');
      if (real) {
        // Bring the header back so its search UI opens in view.
        window.scrollTo({ top: 0, behavior: 'smooth' });
        real.click();
      } else {
        window.location.href = '/search';
      }
    });
  }
})();
